var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./ProductionListingsInner.jinja');
require('./ProductionListingsInner.less');


module.exports = Base.extend({

    template: template,

    events: {
        'click .ProductionListingsInner-item': 'toggleBlock'
    },


    initialize: function (options) {
        this.options = options || {};

        this.isExpanded = false;

        Base.prototype.initialize.call(this, options);
    },


    viewsRegistration: function () {

        Base.prototype.viewsRegistration.call(this);
    },


    toggleAll: function (e) {
        var activeModifier = 'ProductionListingsInner-item--active';

        if (this.isExpanded) {
            this.$('.ProductionListingsInner-item .ProductionListingsInner-itemBlockRolled').slideUp(0);
            this.$('.ProductionListingsInner-item').removeClass(activeModifier);
        } else {
            this.$('.ProductionListingsInner-item .ProductionListingsInner-itemBlockRolled').slideDown(0);
            this.$('.ProductionListingsInner-item').addClass(activeModifier);
        }

        this.isExpanded = !this.isExpanded;

        return this.isExpanded;
    },


    toggleBlock: function (e) {
        var $block = $(e.currentTarget);
        var rolledClass = '.ProductionListingsInner-itemBlockRolled';
        var activeModifier = 'ProductionListingsInner-item--active';

        if ($(e.target).closest(rolledClass).length) return;

        if ($block.hasClass(activeModifier)) {
            $block.find(rolledClass).slideUp(200);
            $block.removeClass(activeModifier);
        } else {
            $block.find(rolledClass).slideDown(200);
            $block.addClass(activeModifier);
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/ProductionListings/ProductionListingsInner.js
// module id = 239
// module chunks = 0